import { render } from "./Form.vue?vue&type=template&id=9e0948ba&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9e0948ba"

export default script